module.exports = {
	"id": "wdwd.logistics.offline.send",
	"description": "发货",
	"meta": {
		"oauth": true
	},
	"requests": {
		"urls": [
			{
				"name": "正式环境",
				"http": "http://openapi.wdwd.com/api/gateway?method=wdwd.logistics.offline.send",
				"https": "https://openapi.wdwd.com/api/gateway?method=wdwd.logistics.offline.send"
			},
			{
				"name": "沙箱环境",
				"http": "http://openapi.sandbox.wdwd.com/api/gateway?method=wdwd.logistics.offline.send",
				"https": "https://openapi.sandbox.wdwd.com/api/gateway?method=wdwd.logistics.offline.send"
			}
		],
		"params": {
			"share": [],
			"private": [
				{
					"name": "tid",
					"type": "string",
					"required": true,
					"description": "订单ID"
				},
				{
					"name": "is_split",
					"type": "int",
					"required": false,
					"description": "是否拆单 1拆单 0不拆单"
				},
				{
					"name": "company_name",
					"type": "string",
					"required": false,
					"description": "快递公司名"
				},
				{
					"name": "company_code",
					"type": "string",
					"required": false,
					"description": "快递公司编码"
				},
				{
					"name": "logistics_no",
					"type": "string",
					"required": false,
					"description": "物流单号"
				},
				{
					"name": "item_list",
					"type": "shipping_item",
					"required": false,
					"description": "具体发货商品信息"
				}
			]
		}
	},
	"responses": {
		"exceptions": [],
		"params": [
			{
				"name": "shipping",
				"type": "shipping",
				"description": "发货单结构，只包含shipping_id和created"
			}
		]
	},
	"structure": [
		{
			"name": "shipping",
			"params": [
				{
					"name": "company_code",
					"type": "string",
					"enumerable": false,
					"description": "快递公司编码"
				},
				{
					"name": "company_name",
					"type": "string",
					"enumerable": false,
					"description": "快递公司名"
				},
				{
					"name": "created",
					"type": "string",
					"enumerable": false,
					"description": "创建时间"
				},
				{
					"name": "is_no_express",
					"type": "string",
					"enumerable": false,
					"description": "是否无需物流 true无需物流"
				},
				{
					"name": "item_list",
					"type": "string",
					"enumerable": false,
					"description": "发货单，发货详情"
				},
				{
					"name": "logistics_no",
					"type": "string",
					"enumerable": false,
					"description": "快递单号"
				},
				{
					"name": "modified",
					"type": "string",
					"enumerable": false,
					"description": "修改时间"
				},
				{
					"name": "shipping_id",
					"type": "string",
					"enumerable": false,
					"description": "发货单ID"
				},
				{
					"name": "tid",
					"type": "string",
					"enumerable": false,
					"description": "订单ID"
				}
			]
		},
		{
			"name": "shipping_item",
			"params": [
				{
					"name": "num",
					"type": "string",
					"enumerable": false,
					"description": "数量"
				},
				{
					"name": "oid",
					"type": "string",
					"enumerable": false,
					"description": "子订单号"
				},
				{
					"name": "shipping_id",
					"type": "string",
					"enumerable": false,
					"description": "发货单号"
				},
				{
					"name": "sku_id",
					"type": "string",
					"enumerable": false,
					"description": "SKU的ID"
				}
			]
		}
	]
};


/*****************
 ** WEBPACK FOOTER
 ** ./app/data/api/wdwd.logistics.offline.send.json
 ** module id = 528
 ** module chunks = 1
 **/